import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { SupportLink } from '../common/SupportLink';
import { ErrorP } from '../common/Typography';
import { useSelector } from 'react-redux';
import { getErrors } from '../../store/policystreamStore';
import { Dispatch, SetStateAction } from 'react';
import { useSettings } from '../../hooks/useSettings/useSettings';

export const PolicyStreamErrorsModal = () => {
  const [open, setOpen] = useState<boolean>(false);
  const errors = useSelector(getErrors);

  useEffect(() => {
    if (Object.values(errors).some((error) => !!error)) {
      setOpen(true);
    }
  }, [errors]);

  if (
    errors?.incompleteQuoteSubmission?.message === 'Coverage amount too high' ||
    errors?.incompleteQuoteSubmission?.message.includes(
      'invalid literal for int()',
    )
  ) {
    return <CoverageAmountTooHigh open={open} setOpen={setOpen} />;
  }

  return (
    <Dialog open={open}>
      <DialogTitle>Error</DialogTitle>
      <DialogContent>
        <Typography>
          There was an error when submitting your application.
        </Typography>
        {errors.incompleteQuoteSubmission ? (
          <ErrorP>{errors.incompleteQuoteSubmission.message}</ErrorP>
        ) : null}
        {errors.completeQuoteSubmission ? (
          <ErrorP>{errors.completeQuoteSubmission.message}</ErrorP>
        ) : null}
        <Typography>
          Please try refreshing the page and try again. If the error persists,
          please contact support at{' '}
          <SupportLink subject='Error submitting PolicyStream application' />.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => window.location.reload()}>Refresh Page</Button>
        <Button onClick={() => setOpen(false)}>OK</Button>
      </DialogActions>
    </Dialog>
  );
};

const CoverageAmountTooHigh = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const { settings } = useSettings();

  return (
    <Dialog open={open}>
      <DialogTitle>Coverage amount too high</DialogTitle>
      <DialogContent>
        <Typography>
          The coverage amount you have requested exceeds the maximum limit we
          are able to process through our online platform. Please contact your
          advisor directly to discuss solutions for higher coverage amounts.
        </Typography>
        <br />
        {settings.email && settings.email != '' && (
          <Typography>
            Email: <a href={`mailto:${settings.email}`}>{settings.email}</a>
          </Typography>
        )}
        {settings.phone && settings.phone != '' && (
          <Typography>
            Phone: <a href={`tel:${settings.phone}`}>{settings.phone}</a>
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => window.location.reload()}>Refresh Page</Button>
        <Button onClick={() => setOpen(false)}>OK</Button>
      </DialogActions>
    </Dialog>
  );
};
